import React from 'react'

const Size = {
    m: 'text-sm placeholder:text-sm px-3 py-[5px]',
    s: 'text-xs placeholder:text-xs px-2 py-1',
    l: 'text-sm placeholder:text-sm px-4 py-[9px]'
}

function TextArea({
    label = "",
    placeholder = "Placeholder",
    size = 'l',
    errorMessage = "Error",
    maxLength = 2000,
    isRequired = false,
    isDisabled = false,
    isReadonly = false,
    isError = false,
    value,
    className,
    name = 'input',
    onValueChange = val => false,
    minHeight = "",
}) {
    return (
        <div className={`flex flex-col ${isDisabled && 'opacity-40'} ${className}`}>
            {label && <label className="text-gray-1100 text-xs mb-1">{label} {isRequired && <span className='text-red-900'>*</span>} </label>}
            <textarea
                value={value}
                name={name}
                className={`border border-gray-200 font-normal hover:border-gray-400 focus:border-black outline-none placeholder:text-gray-1100 ${isError && 'border-red-900'} ${Size[size]} ${minHeight}`}
                placeholder={placeholder}
                maxLength={maxLength}
                disabled={isDisabled}
                isRequired={isRequired}
                isReadonly={isReadonly}
                onChange={(e) => onValueChange(e.target.value)}
                autoComplete='off'
            />
            {
                isError && (
                    <div className='my-1 text-red-900 text-xs'>{errorMessage}</div>
                )
            }
        </div>
    )
}

export default TextArea